import PropTypes from 'prop-types';
import moment from 'moment';
import { getDuration, msToHMS } from '../../helpers';
import { NO_DATA } from '../../constants';

const ProjectWorkSessionLog = ({ worksessionList }) => {
  const capitalizeFirstLetter = (val) =>
    String(val).charAt(0).toUpperCase() + String(val).slice(1);
  return (
    <div className="table-responsive">
      {worksessionList && worksessionList.length > 0 ? (
        <table
          id="groupedDataByProject"
          className="table table-sm table-nowrap table-hover card-table"
        >
          <thead className="thead-light">
            <tr>
              <th>Updated By</th>
              <th>Team Member</th>
              <th>Original Worksession</th>
              <th>Updated Worksession</th>
              <th>Updated Date</th>
              <th>Action</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {worksessionList.map((wsItem, index) => {
              const originalDuration = wsItem.oldCheckInDate
                ? getDuration(wsItem.oldCheckInDate, wsItem.oldCheckOutDate)
                : '';
              const newDuration = wsItem.newCheckInDate
                ? getDuration(wsItem.newCheckInDate, wsItem.newCheckOutDate)
                : '';
              return (
                <tr key={`wsEdit-${index}`}>
                  <td>
                    <div>
                      <p className="text-capitalize mb-0">
                        {wsItem.updatedByFirstName} {wsItem.updatedByLastName}
                        {wsItem.updatedByEmployeeId &&
                          ` (${wsItem.updatedByEmployeeId})`}
                      </p>
                      <small className="text-muted">
                        {wsItem.updatedByEmail}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div>
                      <p className="text-capitalize mb-0">
                        {wsItem.teamMemberfirstName} {wsItem.teamMemberlastName}
                        {wsItem.teamMemberEmployeeId &&
                          ` (${wsItem.teamMemberEmployeeId})`}
                      </p>
                      <small className="text-muted">
                        {wsItem.teamMemberEmail}
                      </small>
                    </div>
                  </td>
                  <td>
                    {originalDuration
                      ? `Duration: ${msToHMS(originalDuration)}`
                      : ''}
                    <br />
                    {wsItem.oldCheckInDate
                      ? `Check-in: ${moment(wsItem.oldCheckInDate).format(
                          'lll'
                        )}`
                      : ''}
                    <br />

                    {wsItem.oldCheckOutDate
                      ? `Check-out: ${moment(wsItem.oldCheckOutDate).format(
                          'lll'
                        )}`
                      : ''}
                  </td>
                  <td>
                    {wsItem.updateType && wsItem.updateType !== 'delete'
                      ? `${
                          newDuration ? `Duration: ${msToHMS(newDuration)}` : ''
                        }`
                      : ''}
                    <br />
                    {wsItem.updateType && wsItem.updateType !== 'delete'
                      ? `${
                          wsItem.newCheckInDate
                            ? `Check-in: ${moment(wsItem.newCheckInDate).format(
                                'lll'
                              )}`
                            : ''
                        }`
                      : ''}
                    <br />

                    {wsItem.updateType && wsItem.updateType !== 'delete'
                      ? `${
                          wsItem.newCheckOutDate
                            ? `Check-out: ${moment(
                                wsItem.newCheckOutDate
                              ).format('lll')}`
                            : ''
                        }`
                      : ''}
                  </td>
                  <td>{moment(wsItem.updatedDate).format('lll')}</td>
                  <td>
                    {(wsItem.updateType &&
                      capitalizeFirstLetter(wsItem.updateType)) ||
                      ''}
                  </td>
                  <td className="capitalize">{wsItem.reason}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p className="m-4 text-center">{NO_DATA.WORKSESSION_EDIT_LOG}</p>
      )}
    </div>
  );
};

ProjectWorkSessionLog.propTypes = {
  worksessionList: PropTypes.array,
};

export default ProjectWorkSessionLog;
